module.exports = __webpack_public_path__ + "static/logo-433447d8f077457c5a169260d7389212.svg";